import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {FontAwesomeButtonEnumTypes} from "./FontAwesomeButtonEnumTypes";
import "./FontAwesomeButton.scss";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";

const FontAwesomeButton = ({icon, title, onClick, extraStyle, extraClasses, enabled = true, buttonType, href}: {
    icon: IconDefinition;
    title?: string;
    onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) => void;
    extraStyle?: React.CSSProperties;
    extraClasses?: string;
    enabled?: boolean;
    buttonType?: FontAwesomeButtonEnumTypes;
    href?: string;
}) => {

    const ico = <span className={`fa-button ${extraClasses ?? ""} ${buttonType?.getMainColor ?? ""} ${buttonType?.getBorderColor ?? ""} ${buttonType?.getAnimationClass ?? ""} ${enabled && (buttonType?.enabled ?? true) ? "" : "fa-button-disabled"} ${onClick || href ? "fa-actionable-button" : "fa-actionfree-button"}`} onClick={enabled ? onClick : null} style={extraStyle}>
        <FontAwesomeIcon
            className={"fa-button-icon"}
            icon={icon}
        />
    </span>;

    if (href)
        return <a title={title} href={href} target={"_blank"} className={"fa-title-wrapper"}>{ico}</a>;
    if (title)
        return <a title={title} className={"fa-title-wrapper"}>{ico}</a>;

    return ico;
};

export default FontAwesomeButton;
